import { Roles } from "@/domains/shared/models/roles";
import { formatTime } from "@/domains/shared/services/format";
import { toast } from "sonner";

export type SessionPresenceUpdatedPayload = {
    sessionId?: string;
    patientName?: string;
    scheduledAt?: string;
    presenceStatus?: string;
    arrivedAt?: string | null;
};

function readPayloadString(
    payload: Record<string, unknown>,
    camelKey: string,
    pascalKey: string,
): string | undefined {
    const value = payload[camelKey] ?? payload[pascalKey];
    return typeof value === "string" ? value : undefined;
}

export function normalizeSessionPresencePayload(raw: unknown): SessionPresenceUpdatedPayload | undefined {
    if (!raw || typeof raw !== "object") {
        return undefined;
    }

    const payload = raw as Record<string, unknown>;
    const scheduledAt = readPayloadString(payload, "scheduledAt", "ScheduledAt");
    const arrivedAtRaw = payload.arrivedAt ?? payload.ArrivedAt;

    return {
        sessionId: readPayloadString(payload, "sessionId", "SessionId"),
        patientName: readPayloadString(payload, "patientName", "PatientName"),
        scheduledAt,
        presenceStatus: readPayloadString(payload, "presenceStatus", "PresenceStatus"),
        arrivedAt:
            arrivedAtRaw === null
                ? null
                : typeof arrivedAtRaw === "string"
                  ? arrivedAtRaw
                  : undefined,
    };
}

export function handleSessionPresenceUpdated(
    payload: SessionPresenceUpdatedPayload | undefined,
    onPresenceUpdated?: () => void,
    viewerRole?: string,
): void {
    onPresenceUpdated?.();

    if (payload?.presenceStatus !== "arrived") {
        return;
    }

    if (viewerRole && viewerRole !== Roles.Therapist) {
        return;
    }

    const name = (payload.patientName ?? "").trim() || "Paciente";
    const timeLabel = payload.scheduledAt ? formatTime(payload.scheduledAt) : "";
    const detail = timeLabel
        ? `${name} chegou para o atendimento das ${timeLabel}.`
        : `${name} chegou para o atendimento.`;
    toast.message(detail);
}
